export function renderBuildGroupFieldArrayHooksFieldArrayTemplate({
  fieldName,
  pascalFieldName
}: {
  fieldName: string
  pascalFieldName: string
}): string {
  return `  const [${fieldName}Expanded, set${pascalFieldName}Expanded] = React.useState('')
  const ${fieldName}FieldArray = useFieldArray({
    control: form.control,
    name: '${fieldName}'
  })`
}
